import { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';

/* Langan Components */
import AdminNavigation from '../../components/admin/admin-navigation/admin-navigation.component';
import BusinessDashboard from '../../components/admin/business-dashboard/BusinessDashboard';
import ManageArea from '../../components/admin/manage-area/ManageArea';
import ManageUsers from '../../components/admin/manage-users/ManageUsers';
import ManageAddresses from '../../components/admin/manage-addresses/ManageAddresses';
import ManageReports from '../../components/admin/manage-reports/ManageReports';
import ManageResources from '../../components/admin/manage-resources/ManageResources';
import ManageLandUseCode from '../../components/admin/manage-lulc/ManageLandUseCode';

/* MUI */
import { makeStyles } from '@material-ui/core/styles';

/* mobx */
import { useLandUseCode } from '../../stores/LandUseCodeStore';


const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexFlow: "column",
    minHeight: "calc(100vh - 200px)",
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
  },
}));

const AdminRouter = () => {
  const classes = useStyles();
  const landUseCodeStore = useLandUseCode();
  
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    landUseCodeStore.fetchLandUseCode()
  }, [landUseCodeStore, refresh]);

  const handleRefreshData = () => {
    setRefresh(!refresh);
    console.log('hit refresh', refresh);
  }

  return (
    <main className={classes.root}>
      <Routes>
        <Route element={<AdminNavigation store={landUseCodeStore}/>}>
          {/* <Route index element={<BusinessDashboard />} /> */}
          {/* <Route path='dashboard' element={<BusinessDashboard />} /> */}
          {/* <Route path='area' element={<ManageArea />} /> */}
          <Route index element={<ManageUsers />} />
          <Route path='users' element={<ManageUsers />} />
          <Route path='addresses' element={<ManageAddresses />} />
          <Route path='landusecode' element={<ManageLandUseCode store={landUseCodeStore} handleRefreshData={handleRefreshData} />} />
          <Route path='reports' element={<ManageReports />} />
          {/* <Route path='resources' element={<ManageResources />} /> */}
        </Route>
      </Routes>
    </main>
  )
};

export default AdminRouter;